// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2xDoq","inputWrap":"Table_inputWrap__PpHon","col":"Table_col__1q7V7","bmiTooltip":"Table_bmiTooltip__3q101"};